// extracted by mini-css-extract-plugin
export var avatarContainer = "_5h-0";
export var avatarTypingWave = "_5h-i";
export var gray = "_5h-f";
export var green = "_5h-c";
export var icon = "_5h-9";
export var image = "_5h-1";
export var lg = "_5h-6";
export var md = "_5h-5";
export var presenceDot = "_5h-b";
export var red = "_5h-d";
export var sm = "_5h-4";
export var status = "_5h-a";
export var typingDot = "_5h-h";
export var typingPill = "_5h-g";
export var xl = "_5h-7";
export var xs = "_5h-3";
export var xxl = "_5h-8";
export var xxs = "_5h-2";
export var yellow = "_5h-e";